module.exports = __webpack_public_path__ + "img/tz3670_center_002.d4cda3b7.png";